import { AppDispatch } from "core/src/store/store.types";
import { useDispatch } from "react-redux";
import { initApp as initAppUC } from "./useCases/init-app/initApp.use-case";

export const useAppUseCases = () => {
	const dispatch = useDispatch<AppDispatch>();

	const initApp = () => dispatch(initAppUC());

	return {
		initApp,
	}
}

export type UseAppUseCases = ReturnType<typeof useAppUseCases>;
